module.exports = __webpack_public_path__ + "img/canva.95e8f554.png";